import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";

const ImageZoom = ({ imageUrl, onClose }) => {
  // Empêcher le scroll de la page quand le modal est ouvert
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Gestionnaire pour fermeture avec touche échap
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  // Utilisation de createPortal pour rendre le composant à la racine du DOM
  return createPortal(
    <div 
      className="image-zoom-overlay" 
      onClick={onClose}
    >
      <div 
        className="image-zoom-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="image-zoom-close" 
          onClick={onClose}
        >
          ×
        </button>
        <img 
          src={imageUrl} 
          alt="Produit agrandi" 
          className="image-zoom-img"
        />
      </div>
    </div>,
    document.body
  );
};

ImageZoom.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ImageZoom;
